import css from "styled-jsx/css";
import styled from "styled-components";
import { Accordion, rdcUiTheme } from "@rdc-npm/rdc-ui";
export const StyledAccordion = styled(Accordion)`
  padding: 24px 0px;
  .chevron-status-wrapper {
  }
  .title .title-icon {
    margin-bottom: -6px;
  }
  .title h2 {
    color: #333333;
    font-size: 19px;
    letter-spacing: 0.6px;
    line-height: 32px;
    font-weight: bold;
    margin-top: 6px;
    margin-left: 10px;
  }
  .chevron-status-wrapper svg {
    font-size: 16px !important;
  }
  @media (max-width: ${rdcUiTheme.screenSize.xs}px) {
    width: ${(props) => props.widthSmallScreen};
  }
`;
// Child component
export const AccordionChild = styled.div`
  padding: 16px;
  height: 100%;
`;
export default css`
  @import "src/static/styles/variables";
  @import "src/static/styles/mixins/mixins";
  .section-divider {
    margin: 0 0 24px 0;
    border-top: 1px solid #757575;
  }
  .bottom-border {
    border-bottom: 1px solid #c8c8c8;
  }
  .preview-main-content {
    width: 688px;
    max-width: 100%;
    float: left;
    position: relative;
    border-bottom: 1px solid #c8c8c8;
    padding-right: 24px;
    padding-left: 24px;
    background: none !important;
  }
  .aboutSectionWrapper {
    display: flex;
    // justify-content: center;
  }
  .hide {
    display: none !important;
  }
  .toaster-section {
    height: 56px !important;

    width: 25%;
    border-radius: 4px;
    background-color: rgba(74, 74, 74, 0.95);
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.06), 0 2px 4px 0 rgba(0, 0, 0, 0.24);
    border-left: 4px solid #549526;
    z-index: 1001;
    position: fixed;
    bottom: 0;
    margin: 1% 38%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    right: 0;
  }
  .toast-msg img,
  span {
    vertical-align: middle;
  }
  .toast-text {
    margin-left: 12px;
    letter-spacing: 0.35px;
    line-height: 20px;
  }
  .toaster-close {
    cursor: pointer;
  }
  .preview-bottom-sheet-container {
    position: relative;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    top: -12px;
    box-shadow: 0 -10px 10px -10px #666;
    background: white !important;
    height: auto;
  }

  .preview-bottom-sheet-container .container {
    padding: 0;
    padding-top: 40px;
  }
  .preview-main {
    margin: 0 auto;
  }
  .main-review {
    width: 100%;
    max-width: 100%;
    position: relative;
    //min-height: 500px;
  }
  .main-review-sub {
    position: relative;
    width: 610px;
    max-width: 100%;
    height: 100%;
  }

  // #main-review-sub div:nth-child(1) {
  //   background: red;
  // }
  .video-content {
    width: 100%;
    max-width: 100%;
    position: relative;
    background: transparent !important;
  }
  @include mobile {
    .preview-main-content {
      border-bottom: none !important;
    }
    .preview-main-content {
      width: 100%;
      max-width: 100%;
      float: left;
      position: relative;
      left: 0%;
      overflow: auto;
      padding-top: 24px;
      padding-left: 24px;
      padding-right: 24px;
    }
    .footer-back-button {
      height: 80px;
      position: relative;
      display: block;
    }
    .banner_preview-back-icon {
      font-size: 18px;
      margin-right: 8px;
      width: 40px;
      height: 40px;
      background-color: rgba(51, 51, 51, 0.4);
      border-radius: 8px;
    }

    .banner_preview-back-icon-right img {
      color: #ffffff;
      text-decoration: none;
      font-weight: 300;
      padding: 8px;
    }
    .banner_preview-back-icon img {
      padding: 8px;
    }

    .footer-back-button .banner_preview-back {
      display: block;
      padding-right: 31px;
    }
    .footer-back-button .container {
      box-shadow: none !important;
      padding: 0 24px !important;
    }
    .banner_preview-back-icon-main {
      margin-left: 2% !important;
      // border-top: 1px solid #c8c8c8;
      padding: 22px 0px;
    }
    .toaster-section {
      width: 75% !important;
      margin: 0% 12% !important;
      flex-direction: unset !important;
    }
    .preview-bottom-sheet-container .container {
      padding-top: 0px !important;
      padding-left: 0px !important;
      padding-right: 0px !important;
      overflow: hidden;
    }
    .preview-main {
      padding-left: unset;
    }
    .main-review {
      width: 100%;
      max-width: 100%;
      left: unset;
    }
    #squarespaceModal1 {
      top: unset;
      bottom: 0px;
      overflow: hidden;
      border-radius: 12px 12px 0 0;
    }
    .aboutSectionWrapper {
      flex-direction: column;
    }
    .main-review {
      width: 100%;
      max-width: 100%;
      left: unset;
    }
    .main-review-sub {
      max-width: 100%;
      position: relative;
      left: 0;
      width: 100%;
      padding-left: 16px;
      padding-right: 16px;
      border-bottom: none;
    }
    .video-content {
      width: 100%;
      background: transparent !important;
    }
    // .bottom-border {
    //   border-bottom: none;
    // }
  }

  @include tab {
    .preview-bottom-sheet-container .container {
      width: 100%;
    }
    .preview-main {
      padding-left: unset;
    }
    .main-review-sub {
      padding-left: 40px;
      padding-right: 40px;
      width: 760px;
    }
    .toaster-section {
      width: 40% !important;
      margin: 0% 28% !important;
      flex-direction: unset !important;
    }
    .preview-main-content {
      border-bottom: none !important;
    }
    .video-content {
      width: 100%;
      background: transparent !important;
    }
  }
  // @include iPadPro {
  //   .main-review-sub {
  //     width: 61%;
  //   }
  // }
  @include normalTab {
    .preview-main-content {
      flex-direction: column;
      width: 80%;
      max-width: 100%;
      float: left;
      position: relative;
      left: 9%;
    }
  }
  // Laptop screen
  @media only screen and (max-width: 1280px) and (min-width: 1024px) {
    .main-review-sub {
      width: 610px !important;
      padding: 0 40px 0 5px !important;
    }
  }
  // Above Laptop
  @media (min-width: 1281px) {
    .preview-bottom-sheet-container .container {
      padding: 40px 16px 0 16px !important;
    }
    .main-review-sub {
      width: 770px !important;
    }
  }
`;
